module.exports = __webpack_public_path__ + "img/03_post it.31931b59.png";